import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from './apiDictionary';
import { getClient } from './client';
import {
  ReaderTaskDraft,
  ReaderTaskDraftBody,
} from '@dynamika-shared/types/reader';
import { calculateDXAScoringMocks } from './mocks/dxaScoring';

export type CalculateScoringProps = {
  clinicalTrialId: string;
  taskId: string;
  body: ReaderTaskDraftBody;
};

export const calculateScoring = (args: CalculateScoringProps) => {
  calculateDXAScoringMocks(args);

  const api = getClient(API_URL.readerTaskCalculate);

  return api.put<ReaderTaskDraft>(
    prepareUrl(API_URL.readerTaskCalculate, [args.taskId]),
    args.body,
    {
      headers: {
        'x-dynamika-clinical-trial-id': args?.clinicalTrialId,
      },
    }
  );
};
